import { useEffect, useState } from "react";
import { Form, Toast, Input, List } from 'antd-mobile'
import { PhotoProvider, PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import CustomScroll from '@src/component/customScroll'
import ProgressBar from "@src/component/ProgressBar";
import BottomIcon from '@src/component/bottomIcon'
import UploadFile from '@src/component/uploadFile'
import { getFinDdata, findSubmit, sendMessage } from '@src/service/applyFormSubService'
import store from '@src/util/store'
import { goto, gotor } from "@src/route";
import sfz from '@src/assets/image/demo_1.jpg'
import rlz from '@src/assets/image/demo_4.jpg'
import jsz from '@src/assets/image/demo_2.png'
import './index.scss'
import refresh2 from '@assets/svg/refresh2.svg'
// 标题
function Title({ title, hint, hint2, remark, onClick }: { title: string, hint: string, hint2?: string, remark?: string, onClick?: any }) {
  return <div className='title-box'>
    <div className='db'>
      <div className='title dotted-line'><span>{title}</span><i onClick={onClick}>{hint}</i></div><div className='hint2'>{hint2}</div>
    </div>
    <div className='remark'>{remark}</div>
  </div>
}
type Cot = {
  title: string,
  content: string
}
type Model = {
  show: boolean,
  content?: string | Array<Cot>
}
interface Preview {
  url?: string | Array<string>
  show: boolean
}
export default function () {
  const [formData, setFormData] = useState<any>()
  const [showCode, setShowCode] = useState<boolean>(true)
  const [showModel, setShowModel] = useState<Model>({ show: false })
  const [checked, setChecked] = useState<boolean>(false)
  const [showPreview, setShowPreview] = useState<Preview>({ url: undefined, show: false })
  const [caFileImgUrl, setCaFileImgUrl] = useState<{ url: string, img: any }>()
  const [otherFileImgUrl, setOtherFileImgUrl] = useState<{ url: string, img: any }>()
  const [signIng, setSignIng] = useState<boolean>(false)
  const [form] = Form.useForm(); //表单数据
  const loanid = store.get('loanid')
  useEffect(() => {
    document.title = '上传资料'
    // 回显数据
    getFinDdata(loanid).then((res) => {
      if (res) {
        if (res.caFileImgUrl) {
          try {
            setCaFileImgUrl({ url: `data:image/png;base64,${res.caFileImgBase64 as string}`, img: `data:image/png;base64,${res.caFileImgBase64 as string}` })
          } catch (error) {
            console.log(error)
          }
        }
        if (res.otherFileImgUrl) {
          try {
            setOtherFileImgUrl({ url: `data:image/png;base64,${res.otherFileImgBase64 as string}`, img: `data:image/png;base64,${res.otherFileImgBase64 as string}` })
          } catch (error) {
            console.log(error)
          }
        }
        if (store.get('fileFrom')) {
          form.setFieldsValue(store.get('fileFrom'))
          setShowCode(store.get('showCode'))
          setFormData(store.get('fileFrom'))
          return
        }
        setShowCode(res.isFixIdentifyAddress)
        setData(res)
        if (!res.driveMain) {
          if (store.get('history')?.loanCredential) {
            setData(store.get('history')?.loanCredential)
          }
        }
      } else {
        if (store.get('history')?.loanCredential) {
          setData(store.get('history')?.loanCredential)
        }
      }
    }).catch(err => {
      if (store.get('history')?.loanCredential) {
        setData(store.get('history')?.loanCredential)
      }
      Toast.show(err?.errmsg || '上传资料查询失败！')
    })
  }, [])

  const setData = (res: any) => {
    const formData: any = {}
    if (res.idf) {
      formData.idf = [{ id: res.idf, url: res.idfUrl }]
    }
    if (res.idb) {
      formData.idb = [{ id: res.idb, url: res.idbUrl }]
    }
    if (res.driveMain) {
      formData.driveMain = [{ id: res.driveMain, url: res.driveMainUrl }]
    }
    if (res.driveSecond) {
      formData.driveSecond = [{ id: res.driveSecond, url: res.driveSecondUrl }]
    }
    if (res.face) {
      formData.face = [{ id: res.face, url: res.faceUrl }]
    }
    if (res.work) {
      formData.work = res.work.map((ret: any) => ({ id: ret.id, url: ret.osskey }))
    }
    if (res.flow) {
      formData.flow = res.flow.map((ret: any) => ({ id: ret.id, url: ret.osskey }))
    }
    if (res.credit) {
      formData.credit = res.credit.map((ret: any) => ({ id: ret.id, url: ret.osskey }))
    }
    if (res.supplement) {
      formData.supplement = res.supplement.map((ret: any) => ({ id: ret.id, url: ret.osskey }))
    }
    form.setFieldsValue(formData)
    setFormData(formData)
  }

  // 提交
  const subClick = () => {
    if (!checked) {
      Toast.show('请阅读相关协议')
      return
    }

    if (!caFileImgUrl || !otherFileImgUrl) {
      Toast.show('请签署《征信授权书》、请签署《委托担保申请书》！')
      return
    }
    const subForm = form.getFieldsValue(true)
    if (!subForm.idf || !subForm.idf.length) {
      Toast.show('请上传身份证正面照')
      return
    }
    if (!subForm.idb || !subForm.idb.length) {
      Toast.show('请上传身份证国徽面')
      return
    }
    if (!subForm.driveMain || !subForm.driveMain.length) {
      Toast.show('请上传摩托车驾驶证主页图片')
      return
    }
    if (!subForm.driveSecond || !subForm.driveSecond.length) {
      Toast.show('请上传摩托车驾驶证副页图片')
      return
    }
    if (!subForm.face || !subForm.face.length) {
      Toast.show('请上传申请人正脸照')
      return
    }
    if (!subForm.work || !subForm.work.length) {
      Toast.show('请上传工作证明')
      return
    }
    // if (!subForm.credit || !subForm.credit.length) {
    //   Toast.show('请上传征信-人行征信电子版')
    //   return
    // }
    if (!subForm.flow || !subForm.flow.length) {
      Toast.show('请上传近6个月工资（经营）流水')
      return
    }
    const subData = { loanid }
    for (const key in subForm) {
      try {
        subData[key] = subForm[key].map((res: any) => res.id).join(',')
      } catch (error) {
        console.log(error)
      }
    }
    Toast.show({
      icon: 'loading',
      content: '资料上传中…',
      duration: 0,
      maskClickable: false
    })
    findSubmit(subData).then(() => {
      store.remove('fileFrom')
      store.remove('showCode')
      Toast.clear()
      gotor('/apply/w5')
    }).catch(err => {
      Toast.show(err?.errmsg || '资料上传失败')
    })
  }

  // 保持数据
  const saveCache = () => {
    store.set('fileFrom', form.getFieldsValue(true))
    store.set('showCode', showCode)
  }

  //  点击征信授权书
  const creditCk = () => {
    if (caFileImgUrl?.url) {
      setShowPreview({ show: true, url: caFileImgUrl?.url })
    } else if (signIng) {
      getQianyue()
    } else {
      faceRecognition()
    }
  }
  //  点击委托担保申请书
  const entrustCk = () => {
    if (otherFileImgUrl?.url) {
      setShowPreview({ show: true, url: otherFileImgUrl?.url })
    } else if (signIng) {
      getQianyue()
    } else {
      faceRecognition()
    }
  }

  // 获取授权信息
  const getQianyue = () => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    getFinDdata(loanid).then((res) => {
      Toast.clear()
      if (res) {
        if (res.caFileImgUrl) {
          try {
            setCaFileImgUrl({ url: `data:image/png;base64,${res.caFileImgBase64 as string}`, img: `data:image/png;base64,${res.caFileImgBase64 as string}` })
          } catch (error) {
            console.log(error)
          }
        }
        if (res.otherFileImgUrl) {
          try {
            setOtherFileImgUrl({ url: `data:image/png;base64,${res.otherFileImgBase64 as string}`, img: `data:image/png;base64,${res.otherFileImgBase64 as string}` })
            return
          } catch (error) {
            console.log(error)
          }
        }
      }
      Toast.show('暂未获取到您的签署状态！')
    }).catch((err) => {
      console.log(err)
    })
  }
  // 发起人脸识别
  const faceRecognition = () => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    sendMessage({ loanid, url: `/customer/cI` }).then(() => {
      Toast.clear()
      Toast.show('短信发送成功，请注意查收！')
      setSignIng(true)
    }).catch(err => {
      Toast.show(err?.errmsg || '查询失败')
    })
  }


  return <div className="page bottomFit material">
    <header>
      <ProgressBar point={95} />
    </header>
    <CustomScroll>
      <Form form={form} layout='horizontal' onValuesChange={() => {
        setFormData(form.getFieldsValue(true))
      }}>
        <div className='img-max-box'>
          {showCode ? <>
            <Title title="申请人身份证" hint="查看示图" onClick={() => { setShowPreview({ show: true, url: sfz }) }}></Title>
            <div className='rw'>
              <div className='gd'>
                <div className='upImg-box233 upImg-box234'>
                  <Form.Item name="idf">
                    <UploadFile maxCount={1} hint="上传身份证人像面" onChanege={() => {
                      console.log(form.getFieldsValue(true))
                    }}></UploadFile>
                  </Form.Item>
                </div>
                <div className='upImg-box233 upImg-box234'>
                  <Form.Item name="idb">
                    <UploadFile maxCount={1} hint="上传身份证国徽面"></UploadFile>
                  </Form.Item>
                </div>
              </div>
            </div>
          </> : <>
            <div className="conceal-inputting">
              <Form.Item name="idf">
                <Input />
              </Form.Item>
              <Form.Item name="idb">
                <Input />
              </Form.Item>
            </div>
          </>}
          <Title title="申请人摩托车驾驶证" hint="查看示图" remark="（没有驾驶证不能放款）" onClick={() => { setShowPreview({ show: true, url: jsz }) }}></Title>
          <div className='rw'>
            <div className='gd'>
              <div className='upImg-box233 upImg-box234'>
                <Form.Item name="driveMain">
                  <UploadFile maxCount={1} hint="上传包含摩托车驾驶证主页的图片"></UploadFile>
                </Form.Item>
              </div>
              <div className='upImg-box233 upImg-box234'>
                <Form.Item name="driveSecond">
                  <UploadFile maxCount={1} hint="上传包含摩托车驾驶证副页的图片"></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
          <Title title="申请人正脸照" hint="查看示图" onClick={() => { setShowPreview({ show: true, url: rlz }) }}></Title>
          <div className='rw'>
            <div className='gd'>
              <div className='upImg-box233 upImg-box234'>
                <Form.Item name="face">
                  <UploadFile maxCount={1}></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
          <Title title="工作证明" hint="查看说明" remark='（六选一即可）' onClick={() => { setShowModel({ show: true, content: [{ title: '1、职员：', content: '纳税明细查询截屏/公积金截屏/社保截屏/工资流水/企业微信或钉钉打卡记录截屏（截图中需显示单位名称）' }, { title: '2、企业主：', content: '营业执照照片（注册满6个月）' }] }) }} hint2={formData?.work?.length ? `已上传${(formData?.work as Array<any>)?.length}张` : ''}></Title>
          <div className='rw'>
            <div className='gd' onTouchMove={(e) => { e.stopPropagation() }}>
              <div className='upImg-box233'>
                <Form.Item name="work">
                  <UploadFile maxCount={15}></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
          <Title title="征信-人行征信电子版" hint="查看说明" onClick={() => { setShowModel({ show: true, content: '可在手机银行APP获取' }) }} hint2={formData?.credit?.length ? `已上传${(formData?.credit as Array<any>)?.length}张` : ''}></Title>
          <div className='rw'>
            <div className='gd' onTouchMove={(e) => { e.stopPropagation() }}>
              <div className='upImg-box233'>
                <Form.Item name="credit">
                  <UploadFile maxCount={15}></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
          <Title title="近6个月工资（经营）流水" hint="查看说明" onClick={() => { setShowModel({ show: true, content: [{ title: '1、职员：', content: '网银工资或收入流水（截图中需显示姓名名）' }, { title: '2、企业主：', content: '电子版经营流水即可' }] }) }} hint2={formData?.flow?.length ? `已上传${(formData?.flow as Array<any>)?.length}张` : ''}></Title>
          <div className='rw'>
            <div className='gd' onTouchMove={(e) => { e.stopPropagation() }}>
              <div className='upImg-box233'>
                <Form.Item name="flow">
                  <UploadFile maxCount={15}></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
          <Title title="其他补充资料" hint="查看说明" onClick={() => { setShowModel({ show: true, content: '如社保公积金、银行流水等' }) }} hint2={formData?.supplement?.length ? `已上传${(formData?.supplement as Array<any>)?.length}张` : ''}></Title>
          <div className='rw'>
            <div className='gd' onTouchMove={(e) => { e.stopPropagation() }}>
              <div className='upImg-box233'>
                <Form.Item name="supplement">
                  <UploadFile maxCount={15}></UploadFile>
                </Form.Item>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <div className="file-list">
        <List>
          <List.Item extra={caFileImgUrl?.url ? '查看' : signIng ? <span className="qs"><img src={refresh2} width={20} alt=""></img>获取签署状态</span> : '获取签署链接'} onClick={() => { creditCk() }} clickable>征信授权书</List.Item>
          <List.Item extra={otherFileImgUrl?.url ? '查看' : signIng ? <span className="qs"><img src={refresh2} width={20} alt=""></img>获取签署状态</span> : '获取签署链接'} onClick={() => { entrustCk() }} clickable>委托担保申请书</List.Item>
        </List>
      </div>
      <footer>
        <div className="checkedbox" onClick={() => { setChecked(!checked) }}>
          <div>
            {checked ? <div className="checked" /> : <div className="no-checked" />}
            <div className="checkedtype">我已阅读并同意<span onClick={(e) => {
              e.stopPropagation()
              saveCache()
              goto('/agreement/auth')
            }}>《资信信息查询授权书》</span><span onClick={(e) => {
              e.stopPropagation()
              saveCache()
              goto('/agreement/credit')
            }}>《百行个人征信信息授权书》</span><span onClick={(e) => {
              e.stopPropagation()
              saveCache()
              goto('/agreement/pa')
            }}>《平台用户协议》</span></div>
          </div>
        </div>
        <div className="button-them submit" onClick={subClick}>提交</div>
      </footer>
      <BottomIcon />
    </CustomScroll>
    {showModel.show && <div className="model-box">
      <div className="model-dx">
        {typeof showModel.content === 'string' && <div className="min-cont">{showModel.content}</div>}
        {Array.isArray(showModel.content) && <div className="arrData">
          {showModel.content.map((res, index) => <div key={index}><div className="title">{res.title}</div><div className="cont">{res.content}</div></div>)}
        </div>}
        <div className="btn" onClick={() => { setShowModel({ show: false }) }}>我知道了</div>
      </div>
    </div>}
    <PhotoProvider>
      <PhotoSlider
        images={showPreview.url ? (typeof showPreview.url === 'string' ? [{ src: showPreview.url, key: 1 }] : showPreview.url?.map((item, index) => ({ src: item, key: index }))) : []}
        visible={showPreview.show}
        onClose={() => setShowPreview({ show: false })}
      />
    </PhotoProvider>
  </div>
}